/**
 * 獲取帳號類型相關
 */
import { Infos, Utils } from '@gov-mo/mpaas-js-bridge';
import { assertQuery } from './urlUtils';
import getQuery from './getQuery';

export enum AccountType {
  // 自然人
  PERSONAL = 'Personal',
  // 私營實體
  'CORP_ENTITY' = 'Corp-Entity',
  // 公營實體
  'GOV_ENTITY' = 'Gov-Entity',
}

const getAccountType = async () => {
  const { accountType: _accountType } = getQuery();
  // 1. URL
  if (assertQuery(_accountType as string)) {
    return assertQuery(_accountType as string) as AccountType;
  }
  // 2. 若是 App 嘗試從 JsApi 獲取
  if (Utils.isGovMoApp()) {
    const rets = await Infos.getCurAccountType();
    if (rets?.success && rets?.data) {
      return rets.data as AccountType;
    }
  }
  // 3. 實在沒有返回 自然人 類型
  return AccountType.CORP_ENTITY;
};

export default getAccountType;
